import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../view/home.vue'
import Login from '../view/login.vue'
import Register from '../view/register.vue'
import Img from '../view/pages/img.vue'
import Img2 from '../view/pages/img2.vue'
// 首页
import Index from '../view/pages/index.vue'
// 公司简介
import Conpany from '../view/pages/conpany.vue'
// 企业资质
import Certification from '../view/pages/certification.vue'
// 联系我们
import Contact from '../view/pages/contact.vue'
// 产品查询
import Product from '../view/pages/product.vue'
// 产品详情
import Particulars from '../view/pages/particulars.vue'
// 行业资讯
import IndustryNews from '../view/pages/industry_news.vue'
// one
import One from '../view/pages/news/one.vue'
// two
import Two from '../view/pages/news/two.vue'
// three
import Three from '../view/pages/news/three.vue'

Vue.use(VueRouter)

// 解决重复点击某个页面报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [{
    path: '/',
    redirect: '/home'
}, {
    path: '/login',
    component: Login
}, {
    path: '/register',
    component: Register
}, {
    path: '/home',
    component: Home,
    redirect: '/index',
    children: [
        {
            path: '/index',
            component: Index
        },
        {
            path: '/conpany',
            component: Conpany
        },
        {
            path: '/certification',
            component: Certification
        },
        {
            path: '/contact',
            component: Contact
        },
        {
            path: '/product',
            component: Product
        },
        {
            path: '/particulars',
            component: Particulars
        },
        {
            path: '/industry_news',
            component: IndustryNews
        },
        {
            path: '/one',
            component: One
        },
        {
            path: '/two',
            component: Two
        },
        {
            path: '/three',
            component: Three
        },
        {
            path: '/img',
            component: Img
        },
        {
            path: '/img2',
            component: Img2
        }
    ]
},
]

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
    //to 将要访问的路径
    //from 代表从哪个路径跳转而来
    //next 是一个函数，表示放行
    // next()  放行  next('/login')  强制跳转

    if (to.path === '/login') return next()
    //获取token
    // const tokenStr = window.sessionStorage.getItem('token')
    // if(!token) return next('/login')
    next()
})

export default router
